
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/u/[user]/sessions",
      function () {
        return require("private-next-pages/u/[user]/sessions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/u/[user]/sessions"])
      });
    }
  